import React, {
  Fragment as _,
  memo,
  useRef,
  useEffect,
  useContext,
} from 'react';
import EditableText from 'components/lib/EditableText';
import Carousel from './Carousel';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Image from 'components/lib/Image';
import { interactionContext as InteractionContext } from './interactionContext';
import Container from 'components/Layouts/ContainerLogical';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import CarouselSlide from './CarouselSlide';
import shouldUpdate from 'services/shouldUpdate';
import SVG from 'components/lib/SVG';
import Carousel_default from 'assets/Wide Image.png';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import { imgPlaceholders } from 'components/lib/Image';
import Transcript from 'components/lib/Video/Transcript';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import Embed from 'components/lib/Embed';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import { ImageContext } from 'components/lib/Image';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;
    const [carousel, txt] = children;

    if (!includeAdditionalTextField) {
      return carousel;
    }

    return (
      <_>
        {carousel}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },
  Video,
  Media,
  Carousel,
  Slide: ({ children, ...props }) => {
    return (
      <ImageContext.Provider
        value={{
          editWrapperType: 1,
          placeholder: Carousel_default,
          editWrapperUseIcon: false,
          padding: 0,
          //
          canUpdateContainerHeight: false,
        }}
      >
        <CarouselSlide {...(props as any)}>{children}</CarouselSlide>
      </ImageContext.Provider>
    );
  },
  Image: ({ children, ...props }) => {
    const interactionContext_ = useContext(InteractionContext);
    const interactionLayout = useRef('TwoColumns');
    const mediaContext = useContext(MediaContext) as IMediaContext;
    const { isAdditionalMedia } = mediaContext;

    useEffect(() => {
      interactionLayout.current = interactionContext_.meta.layout;
    }, []);

    return (
      <Image
        {...{
          ...props,
          placeholder: isAdditionalMedia
            ? imgPlaceholders[1]
            : Carousel_default,
        }}
      />
    );
  },
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  Audio,
  Transcript,
  SVG,
  Embed,
  PDF,
  OpenPDF,
};

const CarouselDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);
  //
  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default CarouselDisplay;
